import React from 'react';
import { TriangleAlert } from 'lucide-react';

interface ErrorStateProps {
  /** What failed, in plain words: "Could not load the threat feed". */
  title: string;
  /** What the person can do, or what the system will do. Never a stack trace or an internal name. */
  children?: React.ReactNode;
  /** Shows a Try again button that calls this. */
  onRetry?: () => void;
  retryLabel?: string;
  /** One line, left aligned: for a failure that sits above figures that stay on screen. */
  compact?: boolean;
  className?: string;
}

/** A read or an action failed (item 72). It is announced at once, and it always offers a way forward. */
const ErrorState: React.FC<ErrorStateProps> = ({ title, children, onRetry, retryLabel = 'Try again', compact = false, className = '' }) => (
  <div className={`ui-state is-error${compact ? ' is-compact' : ''} ${className}`.trim()} role="alert">
    <span className="ui-state-icon" aria-hidden>
      <TriangleAlert size={16} strokeWidth={1.5} />
    </span>
    <p className="ui-state-title">{title}</p>
    {children && <p className="ui-state-text">{children}</p>}
    {onRetry && (
      <div className="ui-state-action">
        <button type="button" className="c3-btn c3-btn-ghost c3-btn-sm" onClick={onRetry}>
          {retryLabel}
        </button>
      </div>
    )}
  </div>
);

export default ErrorState;
